import { Configuration, LogLevel } from '@azure/msal-browser';

// Determine redirect URI based on environment
const redirectUri = window.location.origin;

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: '0ad54c0b-b959-4e33-9423-fd0003ba07c0', // Frontend Application (client) ID
    authority: 'https://login.microsoftonline.com/979fd422-22c4-4a36-bea6-1cf87b6502dd', // Tenant ID
    redirectUri: redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scopes for the API
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

// Scopes for calling the backend API
export const apiRequest = {
  scopes: ['api://6445d6d7-98bf-45da-9131-7a9ad5d0e8a0/access_as_user'],
};

// API base URL - Use environment variable or default to local development
export const apiConfig = {
  baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
};
